import Vue from "vue";
import truncate from "truncate";

Vue.filter("truncate", function(value: string, length: number) {
  return truncate(value, length);
});
